import type { Route } from 'vue-router';
import type { IPost } from '~/types/community';
import type { CommentsSortBy, CommentsSortOrder } from '~/components/utils/commentTree';
import { feedTabKeys } from '~/components/partials/war-room/constants';
import type { WarRoom } from '~/types/store/warRoom';
import type { PostInList } from '~/types/api';

const PER_PAGE = 10;

export function buildPostsQuery(params: Route['params'], query: Route['query']) {
  let tab: WarRoom.FilterByPopularityType = feedTabKeys.MY_FEED_TAB;
  let filter_by_categories;
  let filter_by_topic_slug;

  const { tab: routeTab } = params;

  if (typeof routeTab === 'string') {
    tab = routeTab;
  }

  if (params.categorySlug) {
    filter_by_categories = [params.categorySlug];
  } else if (params.topicSlug) {
    filter_by_topic_slug = params.topicSlug;
  }

  const postsParams: WarRoom.PostsParams = {
    ...query,
    tab,
    filter_by_topic_slug,
    filter_by_categories,
    page: Number(query.page) || 1,
    per_page: PER_PAGE,
  };

  (Object.keys(postsParams) as Array<keyof typeof postsParams>).forEach(key => {
    if (!postsParams[key]) Reflect.deleteProperty(postsParams, key);
  });

  return postsParams;
}

export function buildCommentsQuery(query: Route['query'], page: number): WarRoom.CommentsQueryParams {
  let sort_type: WarRoom.CommentsSortType;

  if (query.sort_comments === 'new') sort_type = 'newest_first';
  else if (query.sort_comments === 'old') sort_type = 'newest_last';

  const commentsQueryParams: WarRoom.CommentsQueryParams = { page };

  if (sort_type) commentsQueryParams.sort_type = sort_type;

  return commentsQueryParams;
}

export function getCommentsSortingParams(query: Route['query']): {
  sortBy: CommentsSortBy;
  sortOrder: CommentsSortOrder;
} {
  const sortBy = query.sort_comments ? 'date' : 'rating';
  const sortOrder = query.sort_comments === 'old' ? 'asc' : 'desc';

  return { sortBy, sortOrder };
}

export const reorder = (posts: Record<string, PostInList>, page: number): Record<string, IPost> =>
  Object.keys(posts).reduce((acct, key) => Object.assign(acct, { [key]: { ...posts[key], page } }), {});
